import { IconType } from 'react-icons/lib';
import { MdOutlinePortrait } from 'react-icons/md';
import {
  AddReminderIcon,
  CallIcon,
  RecruiterQuestionIcon,
  SendEmailIcon,
  SendSmsIcon,
  SubmitCandidateIcon,
  ShareCandidateIcon,
} from 'wisestep-base';

import { MapConversationModIcon } from '../components/MapConversationIcon';
import { UpdateMapConversationModIcon } from '../components/UpdateMapConversationIcon';

export const mappingScrollList = (count: { activity: number; task: number }) => [
  {
    tabName: 'Activity',
    tabCount: count.activity,
  },
  {
    tabName: 'Profile',
  },

  {
    tabName: 'Reminders',
    tabCount: count.task,
  },
  {
    tabName: 'Communications',
  },
  {
    tabName: 'Data Privacy',
    tabCount: count.task,
  },
];

export const submissionScrollList = (tabCount?: number) => [
  {
    tabName: 'Submission',
    tabCount: tabCount && tabCount,
  },
  {
    tabName: 'Timeline',
  },
  {
    tabName: 'Events',
  },
  {
    tabName: 'Communications',
  },
  {
    tabName: 'Candidate Review',
  },
  {
    tabName: 'Data Privacy',
  },
];

interface Action {
  label: string;
  icon: IconType;
}
export const actionList = (isMapped: boolean) => [
  'Send Email',
  'Send SMS',
  'Call',
  `${isMapped ? 'Update Conversation' : 'Map Conversation'}`,
  'Candidate RTR',
  'Setup a Reminder',
  'Submit a Candidate',
  'Share Candidate',
];
// export const actionList = (isMapped: boolean): Action[] => [
//   { label: 'Send Email', icon: MdOutlineEmail },
//   { label: 'Send SMS', icon: MdOutlineSms },
//   { label: 'Call', icon: MdPhone },
//   {
//     label: isMapped ? 'Update Conversation' : 'Map Conversation',
//     icon: TbActivityHeartbeat,
//   },
//   { label: 'Candidate RTR', icon: MdOutlinePortrait },
//   { label: 'Setup a Reminder', icon: MdOutlineCalendarMonth },
//   { label: 'Submit a Candidate', icon: MdSend },
// ];
export const actionListForCrusible = (isMapped: boolean): Action[] => [
  {
    label: isMapped ? 'Update Conversation' : 'Map Conversation',
    icon: isMapped ? UpdateMapConversationModIcon : MapConversationModIcon,
  },
  { label: 'Recruiter Questions', icon: RecruiterQuestionIcon },
  { label: 'Share Candidate', icon: ShareCandidateIcon },
  { label: 'Send Email', icon: SendEmailIcon },
  { label: 'Send SMS', icon: SendSmsIcon },
  { label: 'Call', icon: CallIcon },
  { label: 'Setup a Reminder', icon: AddReminderIcon },
  { label: 'Candidate RTR', icon: MdOutlinePortrait },
  { label: 'Submit a Candidate', icon: SubmitCandidateIcon },
];

export const dncScrollList = () => [
  {
    tabName: 'Profile',
  },
];
